// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3xo5B","author":"Table_author__3zA0e","authorImage":"Table_authorImage__vNEhU","unreadRow":"Table_unreadRow__9dsD4"};